import React from "react";
import style from "./SearchInput.module.scss";

function SearchInput({ searchValue, onChange }) {
  return (
    <div className={style.search_input}>
      <span className={style.icon}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M14.3539 13.6463L11.2245 10.5175C12.1315 9.42859 12.5838 8.03189 12.4873 6.61798C12.3908 5.20407 11.7528 3.88181 10.7062 2.92625C9.65963 1.9707 8.28492 1.45543 6.86808 1.48763C5.45125 1.51983 4.10137 2.09702 3.09926 3.09913C2.09714 4.10125 1.51995 5.45113 1.48775 6.86796C1.45555 8.2848 1.97082 9.65951 2.92637 10.7061C3.88193 11.7527 5.20419 12.3906 6.6181 12.4872C8.03201 12.5837 9.42871 12.1314 10.5176 11.2244L13.6464 14.3538C13.6928 14.4002 13.748 14.4371 13.8087 14.4622C13.8694 14.4874 13.9344 14.5003 14.0001 14.5003C14.0658 14.5003 14.1309 14.4874 14.1916 14.4622C14.2523 14.4371 14.3074 14.4002 14.3539 14.3538C14.4003 14.3073 14.4372 14.2522 14.4623 14.1915C14.4875 14.1308 14.5004 14.0657 14.5004 14C14.5004 13.9343 14.4875 13.8693 14.4623 13.8086C14.4372 13.7479 14.4003 13.6927 14.3539 13.6463ZM2.50014 7.00002C2.50014 6.11 2.76406 5.23998 3.25853 4.49995C3.753 3.75993 4.4558 3.18316 5.27807 2.84256C6.10033 2.50197 7.00513 2.41285 7.87805 2.58649C8.75096 2.76012 9.55279 3.1887 10.1821 3.81804C10.8115 4.44738 11.24 5.2492 11.4137 6.12211C11.5873 6.99503 11.4982 7.89983 11.1576 8.7221C10.817 9.54436 10.2402 10.2472 9.50021 10.7416C8.76019 11.2361 7.89016 11.5 7.00014 11.5C5.80707 11.4987 4.66325 11.0242 3.81962 10.1805C2.976 9.33691 2.50147 8.19309 2.50014 7.00002Z"
            fill="#3A383F"
          />
        </svg>
      </span>
      <input
        type="text"
        placeholder="Search"
        value={searchValue}
        onChange={onChange}
      />
    </div>
  );
}

export default SearchInput;
